<template>
    <div class="auth-page">
        <div class="container-fluid p-0">
            <div class="row g-0 align-items-center">
                <div class="col-xxl-12 col-lg-12 col-md-12">
                    <div class="row justify-content-center g-0">
                        <div class="col-xl-6">
                            <div class="p-4">
                                <div class="card mb-0">
                                    <div class="card-body">
                                        <div class="auth-full-page-content rounded d-flex p-3 my-2">
                                            <div class="w-100">
                                                <div class="d-flex flex-column h-100">
                                                    <div class="mb-4 mb-md-5">
                                                        <router-link to="/" class="d-block auth-logo">
                                                            <img src="@/assets/images/logo.svg" alt="" height="45"
                                                                 class="auth-logo-dark me-start">
                                                            <img src="@/assets/images/logo.svg" alt="" height="45"
                                                                 class="auth-logo-light me-start">
                                                        </router-link>
                                                    </div>
                                                    <div class="auth-content my-auto">
                                                        <div class="text-center">
                                                            <div class="avatar-lg mx-auto">
                                                                <div
                                                                    class="avatar-title bg-light text-primary h1 rounded-circle">
                                                                    <i class="bx bxs-user"></i>
                                                                </div>
                                                            </div>

                                                            <div class="mt-4 pt-2">
                                                                <h5>您已經登出</h5>
                                                                <p class="text-muted font-size-15">謝謝您使用 <span
                                                                    class="fw-semibold text-dark">SaaS 管理系統</span>
                                                                </p>
                                                                <div class="mt-4">
                                                                    <router-link to="/auth/login"
                                                                                 class="btn btn-primary w-100 waves-effect waves-light">
                                                                        到登入頁面
                                                                    </router-link>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mt-4 pt-3 text-center">

                                                        </div>
                                                    </div>
                                                    <div class="mt-4 text-center">
                                                        <p class="mb-0">© {{ new Date().getFullYear() }} 建置與維護 By
                                                            Grapala</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end auth full page content -->
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container fluid -->
    </div>
</template>


<script>

import {authMethods} from "@/state/helpers";

export default {
    mounted() {

        this.setLogout();

    },
    methods: {
        ...authMethods,
        setLogout() {
            return this.logout();
        }

    }
}
</script>
